<template>
    <v-dialog
        v-model="dialog"
        max-width="1000"
    >
        <v-card>
            <div class="close" @click="dialog = !dialog">
                <i class="material-icons">close</i>
            </div>
            <div class="info-block">
                Share Event
            </div>

            <div>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <v-container fluid>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Name</div>
                            </v-flex>
                            <v-flex md10>
                                <v-text-field
                                    label="Package name"
                                    v-model="createForm.name"
                                    :rules="rules.name"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Description</div>
                            </v-flex>
                            <v-flex md10>
                                <v-text-field
                                    label="Package description"
                                    v-model="createForm.description"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Expiration time</div>
                            </v-flex>
                            <v-flex md10>
                                <v-menu
                                    ref="isDatePickerShow"
                                    v-model="isDatePickerShow"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="createForm.dateString"
                                            label="Picker in menu"
                                            prepend-inner-icon="event"
                                            readonly
                                            v-on="on"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="createForm.dateString" :min="minDate" no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="sharedEventUri" justify-center>
                            <router-link :to="`/shared-event/${sharedEventUri}`" target="_blank">
                                    Click to view shared report
                            </router-link>
                        </v-layout>
                        <v-layout row>
                            <v-flex md12 class="text-xs-right">
                                <sp-button @click.native="createSnapshotPackage" sp-class="no-padding-right" small-icon icon="arrow-left" text="Share snapshot"></sp-button>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import SpButton from '@/components/forms/Button'
import moment from 'moment'
import toast from '@/plugins/izitoast'
import { formatDate } from '@/helpers/Utils'
import { DeviceEventSharedApi } from '@/api'

const deviceEventSharedApi = new DeviceEventSharedApi()

export default {
    name: 'ShareEvent',
    mounted () {
        this.createForm.dateString = moment().add(1, 'day').format('YYYY-MM-DD')
        this.minDate = moment().format('YYYY-MM-DD HH:mm')
    },
    components: {
        SpButton
    },
    data () {
        return {
            dialog: false,
            valid: false,
            updateFormValid: false,
            isDatePickerShow: false,
            minDate: null,
            isCreateFormShow: false,
            isUpdateFormShow: false,
            loading: false,
            sharedEventUri: null,
            createForm: {
                name: '',
                description: '',
                dateString: ''
            },
            rules: {
                name: [
                    v => ((v || '').length && 4 <= (v || '').length && 50 >= (v || '').length) || 'Name must be at least 4 and less than 50 characters'
                ]
            }
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
    },
    watch: {
        value: {
            handler () {
                this.dialog = this.value
            }
        },
        dialog (val) {
            this.$emit('input', val)
        }
    },
    methods: {
        async createSnapshotPackage () {
            this.valid = this.$refs.form.validate()
            this.sharedEventUri = null
            if (!this.valid) {
                this.valid = false
                return false
            }

            const response = await deviceEventSharedApi.createDeviceEventShare({
                name: this.createForm.name,
                expirationDate: moment(this.createForm.dateString).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z',
                description: this.createForm.description,
                eventId: this.event.id,
                hardwareId: this.event.hardwareId
            })

            if (!response.isSuccess) {
                return
            }
            this.getSharedEventData(response.payload)
        },
        async getSharedEventData (eventId) {
            const response = await deviceEventSharedApi.getDeviceEventSharedById(eventId)

            if (!response.isSuccess) return

            this.$refs.form.reset()
            this.sharedEventUri = response.payload.uri
            this.createForm.dateString = await moment().add(1, 'day').format('YYYY-MM-DD')
            toast.success('Event shared successfully!')
        },
        dateFormat (date) {
            return formatDate(date)
        }
    }
}
</script>

<style scoped lang="scss">
.info-block {
    margin-bottom: 20px;

    &.info-success {
        border-color: $success;
    }
}

.table-container {
    padding: 24px 16px;
}

.label {
    position: relative;
    top: 14px;
}

.error--text {
    font-size: 12px;
}

.package-input {
    padding: 5px 0;
}

.package-buttons {
    margin-top: 10px;
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
</style>
